import { configureStore } from '@reduxjs/toolkit';
import interactionIdReducer from './reducer';

const store = configureStore({
  reducer: interactionIdReducer,
});
export default store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
